/**
 * 辞書ルール（find → replace）による文字起こし後処理補正
 *
 * ユーザーが登録した「A → B」ルールに基づき、
 * Deepgram の文字起こし結果をリアルタイムで置換する。
 */

import type { VocabRule } from '@/lib/api';

export interface CorrectionRule {
  pattern: RegExp;
  replacement: string;
}

/** VocabRule リストから補正ルール（RegExp）を生成 */
export function buildCorrectionRules(rules: VocabRule[]): CorrectionRule[] {
  return rules.map(rule => ({
    pattern: new RegExp(escapeRegex(rule.findText), 'g'),
    replacement: rule.replaceText,
  }));
}

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** 文字起こしテキストに辞書補正を適用 */
export function applyVocabularyCorrections(text: string, rules: CorrectionRule[]): string {
  let result = text;
  for (const rule of rules) {
    result = result.replace(rule.pattern, rule.replacement);
  }
  return result;
}

/** Deepgram WebSocket URL 用の replace パラメータを生成 */
export function buildDeepgramReplaceParams(rules: VocabRule[]): string {
  // Deepgram replace: 最大200件
  return rules
    .slice(0, 200)
    .map(r => `replace=${encodeURIComponent(r.findText)}:${encodeURIComponent(r.replaceText)}`)
    .join('&');
}
